module.exports = __webpack_public_path__ + "img/3_5_bonus_20_line.3d93eb5a.png";